import { ChangeDetectorRef, Component, Input, OnDestroy, OnInit } from '@angular/core';
import { AuthService } from "../../services/auth.service";
import { App } from "ionic-angular";
import { EventService } from "../../services/event.service";
import { NotificationService } from "../../services/notification.service";
import { Subscription } from "rxjs/Subscription";


@Component({
  selector: 'tab-bar',
  templateUrl: 'tab-bar.html'
})
export class TabBar implements OnInit, OnDestroy {

  @Input() mobileSidebarActive: boolean = false;
  
  private onNotificationUpdateSubscription: Subscription;
  
  constructor(public authService: AuthService,
              public eventService: EventService,
              private changeDetector: ChangeDetectorRef,
              public notificationService: NotificationService,
              public app: App) {
    
  }

  openSearch():void{
		this.eventService.doSearch.emit(null);
		this.eventService.toggleMobileSidebar.emit(false);
	}


  ngOnInit(): void {
    this.onNotificationUpdateSubscription = this.notificationService.onUnreadChanged.subscribe(()=>{
      this.changeDetector.detectChanges();
    })
  }

  ngOnDestroy(): void {
    if(this.onNotificationUpdateSubscription) this.onNotificationUpdateSubscription.unsubscribe();
  }
  
  propagateScrollToTop(){
    if(!this.mobileSidebarActive) {
      this.eventService.scrollToTop.emit();
    }
  }

}



// WEBPACK FOOTER //
// ./src/partials/tab-bar/tab-bar.ts